[
  {
    "id": "kingdom_infantry",
    "name": "Kingdom Infantry",
    "factionId": "humans",
    "attack": 4,
    "defence": 5,
    "health": 12,
    "damageMin": 2,
    "damageMax": 4,
    "specialty": "Disciplined line troops. No great strength anywhere, no great weakness either.",
    "initiative": 5,
    "tags": [
      "infantry"
    ],
    "damageType": "physical",
    "resistances": [],
    "specialAction": {
      "id": "kingdom_infantry_shieldwall",
      "name": "Shield Wall",
      "description": "Lock shields: this stack defends, and every allied stack gains the defending bonus this round.",
      "kind": "shieldwall"
    }
  },
  {
    "id": "human_crossbowmen",
    "name": "Human Crossbowmen",
    "factionId": "humans",
    "attack": 5,
    "defence": 2,
    "health": 8,
    "damageMin": 2,
    "damageMax": 6,
    "specialty": "Bolts punch through armour, but the crew is helpless if anything reaches them.",
    "initiative": 7,
    "tags": [
      "ranged"
    ],
    "damageType": "piercing",
    "resistances": [],
    "specialAction": {
      "id": "human_crossbowmen_volley",
      "name": "Massed Volley",
      "description": "Every bolt at once: heavy damage, but the crews spend the next round reloading.",
      "kind": "volley"
    }
  },
  {
    "id": "orc_raiders",
    "name": "Orc Raiders",
    "factionId": "orcs",
    "attack": 5,
    "defence": 3,
    "health": 10,
    "damageMin": 2,
    "damageMax": 5,
    "specialty": "Fast, numerous, and only dangerous while they think they are winning.",
    "initiative": 6,
    "tags": [
      "infantry"
    ],
    "damageType": "physical",
    "resistances": []
  },
  {
    "id": "orc_berserkers",
    "name": "Orc Berserkers",
    "factionId": "orcs",
    "attack": 7,
    "defence": 2,
    "health": 14,
    "damageMin": 3,
    "damageMax": 7,
    "specialty": "They do not defend. They do not need to, for a while.",
    "initiative": 8,
    "tags": [
      "infantry"
    ],
    "damageType": "physical",
    "resistances": [],
    "specialAction": {
      "id": "orc_berserkers_frenzy",
      "name": "Blood Frenzy",
      "description": "Strike wildly for far greater damage, at the cost of all defence until the next turn.",
      "kind": "frenzy"
    }
  },
  {
    "id": "trainee_duelist",
    "name": "You (in training)",
    "factionId": "humans",
    "hideFromRoster": true,
    "attack": 8,
    "defence": 8,
    "health": 42,
    "damageMin": 5,
    "damageMax": 9,
    "specialty": "You, with a practice blade and more confidence than skill.",
    "initiative": 10,
    "tags": [
      "hero"
    ],
    "damageType": "physical",
    "resistances": [],
    "specialAction": {
      "id": "trainee_duelist_charge",
      "name": "Reckless Opening",
      "description": "Throw yourself at the opening you think you see: double damage, guard dropped until your next turn.",
      "kind": "charge"
    }
  },
  {
    "id": "veteran_duelist",
    "name": "You (advanced swordsmanship)",
    "factionId": "humans",
    "hideFromRoster": true,
    "attack": 10,
    "defence": 8,
    "health": 48,
    "damageMin": 6,
    "damageMax": 10,
    "specialty": "You, after a great many repeated mornings on the practice yard.",
    "initiative": 12,
    "tags": [
      "hero"
    ],
    "damageType": "physical",
    "resistances": [],
    "specialAction": {
      "id": "veteran_duelist_charge",
      "name": "Killing Stroke",
      "description": "Commit everything to one opening: double damage, but your guard drops until your next turn.",
      "kind": "charge"
    }
  },
  {
    "id": "ironwatch_champion",
    "name": "Ironwatch Champion",
    "factionId": "humans",
    "attack": 10,
    "defence": 8,
    "health": 44,
    "damageMin": 5,
    "damageMax": 10,
    "specialty": "The best blade in the fortress, and entirely aware of it.",
    "initiative": 11,
    "tags": [
      "hero"
    ],
    "damageType": "physical",
    "resistances": [],
    "specialAction": {
      "id": "ironwatch_champion_charge",
      "name": "Champion's Opening",
      "description": "A practised killing stroke: double damage, guard dropped until the next turn.",
      "kind": "charge"
    }
  },
  {
    "id": "high_elf_archers",
    "name": "High Elf Archers",
    "factionId": "high_elves",
    "attack": 6,
    "defence": 3,
    "health": 9,
    "damageMin": 6,
    "damageMax": 9,
    "specialty": "Trained for centuries to put an arrow through a wingbeat. Dragons die to these.",
    "initiative": 9,
    "tags": [
      "ranged"
    ],
    "damageType": "piercing",
    "resistances": [],
    "counters": {
      "dragon": 2.2
    },
    "specialAction": {
      "id": "high_elf_archers_volley",
      "name": "Starfall Volley",
      "description": "A single arcing volley loosed as one: heavy damage, then a round spent re-nocking.",
      "kind": "volley"
    }
  },
  {
    "id": "high_elf_lancers",
    "name": "High Elf Lancers",
    "factionId": "high_elves",
    "attack": 7,
    "defence": 6,
    "health": 44,
    "damageMin": 12,
    "damageMax": 15,
    "specialty": "Heavy horse that hits hardest on the first pass.",
    "initiative": 10,
    "tags": [
      "cavalry"
    ],
    "damageType": "physical",
    "resistances": [],
    "specialAction": {
      "id": "high_elf_lancers_charge",
      "name": "Lance Charge",
      "description": "Ride the enemy down: double damage, but the formation is scattered until the next turn.",
      "kind": "charge"
    }
  },
  {
    "id": "dwarven_shieldbearers",
    "name": "Dwarven Shieldbearers",
    "factionId": "dwarves",
    "attack": 6,
    "defence": 15,
    "health": 18,
    "damageMin": 4,
    "damageMax": 6,
    "specialty": "Bred on mountain wars. They know exactly where a giant's knee is, and how to take a wall.",
    "initiative": 4,
    "tags": [
      "infantry"
    ],
    "damageType": "physical",
    "resistances": [
      "physical"
    ],
    "counters": {
      "giant": 2.2,
      "fortification": 2
    },
    "specialAction": {
      "id": "dwarven_shieldbearers_shieldwall",
      "name": "Mountain Wall",
      "description": "An immovable line: this stack defends and every allied stack gains the defending bonus this round.",
      "kind": "shieldwall"
    }
  },
  {
    "id": "dwarven_hammerguard",
    "name": "Dwarven Hammerguard",
    "factionId": "dwarves",
    "attack": 8,
    "defence": 16,
    "health": 18,
    "damageMin": 12,
    "damageMax": 24,
    "specialty": "War hammers made for breaking gates, and things the size of gates.",
    "initiative": 5,
    "tags": [
      "infantry"
    ],
    "damageType": "physical",
    "resistances": [
      "fire"
    ],
    "counters": {
      "fortification": 2.4,
      "giant": 1.8
    },
    "specialAction": {
      "id": "dwarven_hammerguard_sunder",
      "name": "Sunder",
      "description": "A hammer blow that ignores the target's defence and resistances entirely.",
      "kind": "sunder"
    }
  },
  {
    "id": "wood_elf_pathfinders",
    "name": "Wood Elf Pathfinders",
    "factionId": "wood_elves",
    "attack": 6,
    "defence": 6,
    "health": 20,
    "damageMin": 5,
    "damageMax": 8,
    "specialty": "They read a forest the way others read a page. Nothing stays hidden from them for long.",
    "initiative": 17,
    "tags": [
      "ranged"
    ],
    "damageType": "piercing",
    "resistances": [],
    "counters": {
      "dark_elf": 2
    },
    "specialAction": {
      "id": "wood_elf_pathfinders_reveal",
      "name": "Read the Ground",
      "description": "Call out every hidden position: all concealed enemy stacks become targetable and lose their ambush edge.",
      "kind": "reveal"
    }
  },
  {
    "id": "ritual_mages",
    "name": "Ritual Mages",
    "factionId": "spellcasters",
    "attack": 7,
    "defence": 3,
    "health": 8,
    "damageMin": 3,
    "damageMax": 7,
    "specialty": "Trained to unmake bindings. Demon rifts and necromantic anchors are bindings.",
    "initiative": 8,
    "tags": [
      "ranged"
    ],
    "damageType": "arcane",
    "resistances": [
      "arcane"
    ],
    "counters": {
      "anchor": 2.6,
      "demon": 2.2
    },
    "specialAction": {
      "id": "ritual_mages_banish",
      "name": "Unbinding",
      "description": "Tear the pattern apart: devastating against undead, demons and anchors, useless against anything else.",
      "kind": "banish"
    }
  },
  {
    "id": "flame_guard",
    "name": "Flame Guard",
    "factionId": "spellcasters",
    "attack": 7,
    "defence": 5,
    "health": 12,
    "damageMin": 4,
    "damageMax": 8,
    "specialty": "Fire is the one thing a troll cannot simply grow back.",
    "initiative": 6,
    "tags": [
      "infantry"
    ],
    "damageType": "fire",
    "resistances": [
      "fire"
    ],
    "counters": {
      "troll": 2.4
    }
  },
  {
    "id": "spirit_wardens",
    "name": "Spirit Wardens",
    "factionId": "good_spirits",
    "attack": 8,
    "defence": 5,
    "health": 11,
    "damageMin": 3,
    "damageMax": 7,
    "specialty": "They fight what cannot be cut. The dead and the possessed both answer to them.",
    "initiative": 9,
    "tags": [
      "spirit"
    ],
    "damageType": "holy",
    "resistances": [
      "shadow"
    ],
    "counters": {
      "undead": 2.3,
      "demon": 1.9
    },
    "specialAction": {
      "id": "spirit_wardens_banish",
      "name": "Banishment",
      "description": "Sever what holds a thing to the world: devastating against undead, demons and anchors only.",
      "kind": "banish"
    }
  },
  {
    "id": "young_dragon",
    "name": "Young Dragon",
    "factionId": "dragons",
    "attack": 12,
    "defence": 16,
    "health": 420,
    "damageMin": 25,
    "damageMax": 45,
    "specialty": "Armoured in scale and contempt. Only massed archery brings one down.",
    "initiative": 11,
    "tags": [
      "dragon",
      "beast"
    ],
    "damageType": "fire",
    "resistances": [
      "fire",
      "physical"
    ]
  },
  {
    "id": "cave_troll",
    "name": "Cave Trolls",
    "factionId": "trolls",
    "attack": 9,
    "defence": 7,
    "health": 90,
    "damageMin": 10,
    "damageMax": 18,
    "specialty": "Wounds close as fast as they open. Only fire makes them permanent.",
    "initiative": 3,
    "tags": [
      "troll",
      "beast"
    ],
    "damageType": "physical",
    "resistances": [
      "physical"
    ],
    "specialAction": {
      "id": "cave_troll_regenerate",
      "name": "Knit Flesh",
      "description": "Torn muscle closes over: the stack recovers a large part of its lost strength.",
      "kind": "regenerate"
    }
  },
  {
    "id": "hill_giant",
    "name": "Hill Giants",
    "factionId": "giants",
    "attack": 10,
    "defence": 8,
    "health": 120,
    "damageMin": 14,
    "damageMax": 24,
    "specialty": "Enormous, slow, and used to nothing being able to reach them below the waist.",
    "initiative": 2,
    "tags": [
      "giant"
    ],
    "damageType": "physical",
    "resistances": []
  },
  {
    "id": "skeletal_legion",
    "name": "Skeletal Legion",
    "factionId": "undead",
    "attack": 5,
    "defence": 6,
    "health": 8,
    "damageMin": 2,
    "damageMax": 4,
    "specialty": "Arrows pass between the ribs of things that no longer need organs.",
    "initiative": 4,
    "tags": [
      "undead"
    ],
    "damageType": "physical",
    "resistances": [
      "piercing",
      "shadow"
    ]
  },
  {
    "id": "wraith",
    "name": "Wraiths",
    "factionId": "undead",
    "attack": 9,
    "defence": 5,
    "health": 26,
    "damageMin": 6,
    "damageMax": 12,
    "specialty": "Steel finds nothing to bite. Only holy or arcane force touches them.",
    "initiative": 10,
    "tags": [
      "undead",
      "spirit"
    ],
    "damageType": "shadow",
    "resistances": [
      "physical",
      "piercing",
      "shadow"
    ]
  },
  {
    "id": "dark_elf_stalkers",
    "name": "Dark Elf Stalkers",
    "factionId": "dark_elves",
    "attack": 8,
    "defence": 5,
    "health": 10,
    "damageMin": 4,
    "damageMax": 7,
    "specialty": "You cannot fight what you cannot find. Someone has to find them first.",
    "initiative": 12,
    "tags": [
      "dark_elf",
      "ranged"
    ],
    "damageType": "piercing",
    "resistances": [],
    "startsConcealed": true
  },
  {
    "id": "rift_spawn",
    "name": "Rift Spawn",
    "factionId": "demon_spirits",
    "attack": 8,
    "defence": 6,
    "health": 20,
    "damageMin": 5,
    "damageMax": 11,
    "specialty": "Whatever crawls through the tear. Killing them means nothing while the tear remains.",
    "initiative": 7,
    "tags": [
      "demon"
    ],
    "damageType": "shadow",
    "resistances": [
      "shadow",
      "physical"
    ]
  },
  {
    "id": "necromantic_anchor",
    "name": "Necromantic Anchor",
    "factionId": "undead",
    "attack": 2,
    "defence": 12,
    "health": 200,
    "damageMin": 3,
    "damageMax": 6,
    "specialty": "A bound stone holding the dead upright. Steel scratches it. Ritual force ends it.",
    "initiative": 1,
    "tags": [
      "anchor",
      "fortification"
    ],
    "damageType": "shadow",
    "resistances": [
      "physical",
      "piercing",
      "fire"
    ]
  },
  {
    "id": "the_chosen",
    "name": "You",
    "factionId": "humans",
    "hideFromRoster": true,
    "attack": 12,
    "defence": 10,
    "health": 90,
    "damageMin": 10,
    "damageMax": 18,
    "specialty": "Whatever you have made of yourself so far. Swordsmanship decides how much this stack is actually worth, and it is the one stack that is always in the fight whether or not you brought an army.",
    "initiative": 14,
    "tags": [
      "hero"
    ],
    "damageType": "physical",
    "resistances": [],
    "specialAction": {
      "id": "the_chosen_charge",
      "name": "Commit",
      "description": "Everything into one stroke, and no guard left afterwards.",
      "kind": "charge"
    }
  },
  {
    "id": "vane_cutthroats",
    "name": "Hired Cutthroats",
    "factionId": "humans",
    "hideFromRoster": true,
    "attack": 7,
    "defence": 4,
    "health": 9,
    "damageMin": 3,
    "damageMax": 6,
    "specialty": "Paid that morning, briefed the night before, and told exactly which face to look for. They are not good; they simply already know where you will be.",
    "initiative": 11,
    "tags": [
      "infantry"
    ],
    "damageType": "physical",
    "resistances": []
  },
  {
    "id": "vane_ambushers",
    "name": "Vane's Ambushers",
    "factionId": "humans",
    "hideFromRoster": true,
    "attack": 9,
    "defence": 5,
    "health": 11,
    "damageMin": 4,
    "damageMax": 8,
    "specialty": "They chose this ground days ago and they have been lying in it since before light. Pathfinders find them; nothing else does.",
    "initiative": 13,
    "tags": [
      "infantry"
    ],
    "damageType": "piercing",
    "resistances": [],
    "startsConcealed": true
  },
  {
    "id": "vane_turncoats",
    "name": "Turned Soldiers",
    "factionId": "humans",
    "hideFromRoster": true,
    "attack": 8,
    "defence": 7,
    "health": 14,
    "damageMin": 4,
    "damageMax": 7,
    "specialty": "Your own colours, your own drill, your own orders — given in your name by a man they had no reason to doubt. They do not know they are on the wrong side.",
    "initiative": 8,
    "tags": [
      "infantry"
    ],
    "damageType": "physical",
    "resistances": [],
    "specialAction": {
      "id": "vane_turncoats_shieldwall",
      "name": "Close Ranks",
      "description": "Locks shields and steadies every stack beside them for the round.",
      "kind": "shieldwall"
    }
  },
  {
    "id": "aldric_vane",
    "name": "Aldric Vane",
    "factionId": "humans",
    "hideFromRoster": true,
    "attack": 17,
    "defence": 14,
    "health": 150,
    "damageMin": 14,
    "damageMax": 26,
    "specialty": "He has fought this exact fight more times than you have been alive, and he has lost it enough times to have stopped making the mistakes. Steel will win the field and change nothing.",
    "initiative": 16,
    "tags": [
      "hero"
    ],
    "damageType": "physical",
    "resistances": [
      "shadow"
    ],
    "counters": {
      "infantry": 1.6
    },
    "specialAction": {
      "id": "aldric_vane_sunder",
      "name": "The Opening He Remembers",
      "description": "A stroke he has had several lifetimes to find. Ignores defence and resistances entirely.",
      "kind": "sunder"
    }
  },
  {
    "id": "kingdom_knights",
    "name": "Kingdom Knights",
    "factionId": "humans",
    "attack": 12,
    "defence": 7,
    "health": 52,
    "damageMin": 6,
    "damageMax": 16,
    "specialty": "The Crown's heavy horse. Slow to muster, but there is nothing in the heartland they cannot ride down once they have.",
    "initiative": 12,
    "tags": ["cavalry"],
    "damageType": "physical",
    "resistances": ["physical"],
    "specialAction": {
      "id": "kingdom_knights_charge",
      "name": "Knightly Charge",
      "description": "Ride the enemy down: double damage, guard dropped until the next turn.",
      "kind": "charge"
    }
  },
  {
    "id": "high_elf_mistblades",
    "name": "High Elf Mistblades",
    "factionId": "high_elves",
    "attack": 8,
    "defence": 6,
    "health": 65,
    "damageMin": 4,
    "damageMax": 7,
    "specialty": "Bladework older than the kingdom, edges dressed in cold light. The dead and the possessed feel these where they feel nothing else.",
    "initiative": 10,
    "tags": ["infantry"],
    "damageType": "arcane",
    "resistances": ["arcane", "shadow"],
    "counters": { "undead": 1.7, "spirit": 1.6 },
    "specialAction": {
      "id": "high_elf_mistblades_sunder",
      "name": "Mistcut",
      "description": "A stroke that finds the seam in anything: ignores the target's defence and resistances.",
      "kind": "sunder"
    }
  },
  {
    "id": "dwarven_cannoneers",
    "name": "Dwarven Cannoneers",
    "factionId": "dwarves",
    "attack": 7,
    "defence": 8,
    "health": 13,
    "damageMin": 8,
    "damageMax": 28,
    "specialty": "Forge-cast guns made for cracking mountain gates. What breaks a wall breaks a giant, and does not much care about scale either.",
    "initiative": 4,
    "tags": ["ranged"],
    "damageType": "piercing",
    "resistances": ["fire"],
    "counters": { "fortification": 2.4, "giant": 2, "dragon": 1.6 },
    "specialAction": {
      "id": "dwarven_cannoneers_volley",
      "name": "Full Broadside",
      "description": "Every gun at once: heavy damage, then a round spent swabbing and reloading.",
      "kind": "volley"
    }
  },
  {
    "id": "wood_elf_longbows",
    "name": "Wood Elf Longbows",
    "factionId": "wood_elves",
    "attack": 6,
    "defence": 3,
    "health": 9,
    "damageMin": 3,
    "damageMax": 6,
    "specialty": "They loose through canopy at things they can barely see. A wingbeat overhead is an easier target than most.",
    "initiative": 9,
    "tags": ["ranged"],
    "damageType": "piercing",
    "resistances": [],
    "counters": { "beast": 1.7, "dragon": 1.6 },
    "specialAction": {
      "id": "wood_elf_longbows_volley",
      "name": "Canopy Volley",
      "description": "A single arcing volley loosed as one: heavy damage, then a round spent re-nocking.",
      "kind": "volley"
    }
  },
  {
    "id": "wood_elf_thornguard",
    "name": "Wood Elf Thornguard",
    "factionId": "wood_elves",
    "attack": 6,
    "defence": 7,
    "health": 15,
    "damageMin": 3,
    "damageMax": 6,
    "specialty": "The rangers who stand and hold when the rest fade back into the trees. They have fought their estranged Nightweb kin before and know their tricks.",
    "initiative": 6,
    "tags": ["infantry"],
    "damageType": "physical",
    "resistances": ["physical"],
    "counters": { "dark_elf": 1.9 },
    "specialAction": {
      "id": "wood_elf_thornguard_shieldwall",
      "name": "Thorn Line",
      "description": "A braced line: this stack defends and every allied stack gains the defending bonus this round.",
      "kind": "shieldwall"
    }
  },
  {
    "id": "storm_callers",
    "name": "Storm Callers",
    "factionId": "spellcasters",
    "attack": 8,
    "defence": 3,
    "health": 9,
    "damageMin": 4,
    "damageMax": 9,
    "specialty": "The Rift Observatory's lightning-handlers. A bolt does not care how thick a dragon's scale is, and it reaches things in the air that arrows strain to.",
    "initiative": 8,
    "tags": ["ranged"],
    "damageType": "arcane",
    "resistances": ["arcane"],
    "counters": { "dragon": 1.9, "beast": 1.8 },
    "specialAction": {
      "id": "storm_callers_volley",
      "name": "Chain Lightning",
      "description": "The whole storm at once: heavy damage, then a round spent gathering charge again.",
      "kind": "volley"
    }
  },
  {
    "id": "radiant_seraph",
    "name": "Radiant Seraph",
    "factionId": "good_spirits",
    "attack": 9,
    "defence": 6,
    "health": 17,
    "damageMin": 4,
    "damageMax": 9,
    "specialty": "The brightest of the Whispering Lake's watchers. Undead and demons both come apart under it the way frost comes apart in sun.",
    "initiative": 11,
    "tags": ["spirit"],
    "damageType": "holy",
    "resistances": ["shadow"],
    "counters": { "undead": 2.3, "demon": 2.2, "anchor": 1.8 },
    "specialAction": {
      "id": "radiant_seraph_banish",
      "name": "Radiance",
      "description": "Unmake what holds a thing to the world: devastating against undead, demons and anchors only.",
      "kind": "banish"
    }
  },
  {
    "id": "ancestor_shades",
    "name": "Ancestor Shades",
    "factionId": "good_spirits",
    "attack": 7,
    "defence": 5,
    "health": 12,
    "damageMin": 3,
    "damageMax": 7,
    "specialty": "The honoured dead of the Hall of Ancestors, who see what hides because they are half in the same dark. Nothing stays concealed from them.",
    "initiative": 8,
    "tags": ["spirit"],
    "damageType": "holy",
    "resistances": ["shadow", "physical"],
    "counters": { "undead": 1.8, "dark_elf": 1.6 },
    "specialAction": {
      "id": "ancestor_shades_reveal",
      "name": "The Watching Dead",
      "description": "Call out every hidden position: all concealed enemy stacks become targetable and lose their ambush edge.",
      "kind": "reveal"
    }
  },
  {
    "id": "nomad_horse_archers",
    "name": "Nomad Horse Archers",
    "factionId": "nomads",
    "attack": 6,
    "defence": 4,
    "health": 11,
    "damageMin": 3,
    "damageMax": 6,
    "specialty": "They shoot backward at a full gallop and are gone before the answer lands. Numbers and speed both, and only dangerous to catch.",
    "initiative": 11,
    "tags": ["cavalry", "ranged"],
    "damageType": "piercing",
    "resistances": [],
    "specialAction": {
      "id": "nomad_horse_archers_volley",
      "name": "Parthian Volley",
      "description": "The whole line looses over its shoulder at once: heavy damage, then a round spent wheeling about.",
      "kind": "volley"
    }
  },
  {
    "id": "nomad_lancers",
    "name": "Nomad Lancers",
    "factionId": "nomads",
    "attack": 8,
    "defence": 6,
    "health": 15,
    "damageMin": 4,
    "damageMax": 8,
    "specialty": "The heavy banners of the steppe, kept back until the horse archers have worn a line thin enough to break.",
    "initiative": 10,
    "tags": ["cavalry"],
    "damageType": "physical",
    "resistances": [],
    "specialAction": {
      "id": "nomad_lancers_charge",
      "name": "Banner Charge",
      "description": "Ride the enemy down: double damage, formation scattered until the next turn.",
      "kind": "charge"
    }
  },
  {
    "id": "nomad_outriders",
    "name": "Nomad Outriders",
    "factionId": "nomads",
    "attack": 6,
    "defence": 5,
    "health": 12,
    "damageMin": 3,
    "damageMax": 6,
    "specialty": "Scouts who read the open country the way the Wood Elves read a forest. What is hiding on the steppe does not stay hidden from them.",
    "initiative": 12,
    "tags": ["cavalry"],
    "damageType": "physical",
    "resistances": [],
    "counters": { "dark_elf": 1.6 },
    "specialAction": {
      "id": "nomad_outriders_reveal",
      "name": "Read the Steppe",
      "description": "Call out every hidden position: all concealed enemy stacks become targetable and lose their ambush edge.",
      "kind": "reveal"
    }
  },
  {
    "id": "orc_wolf_riders",
    "name": "Orc Wolf Riders",
    "factionId": "orcs",
    "attack": 7,
    "defence": 3,
    "health": 13,
    "damageMin": 3,
    "damageMax": 7,
    "specialty": "The raiders' fast wing, mounted on things with too many teeth. First to a village and first to run once the tide turns.",
    "initiative": 9,
    "tags": ["cavalry", "beast"],
    "damageType": "physical",
    "resistances": [],
    "specialAction": {
      "id": "orc_wolf_riders_charge",
      "name": "Wolf Rush",
      "description": "Break into a headlong charge: double damage, guard dropped until the next turn.",
      "kind": "charge"
    }
  },
  {
    "id": "elder_dragon",
    "name": "Elder Dragon",
    "factionId": "dragons",
    "attack": 15,
    "defence": 21,
    "health": 540,
    "damageMin": 35,
    "damageMax": 60,
    "specialty": "Vharethyx itself, older than the mountain it sleeps under. Steel is an insult and fire is a language it speaks. Only centuries of massed archery have ever answered one.",
    "initiative": 12,
    "tags": ["dragon", "beast"],
    "damageType": "fire",
    "resistances": ["fire", "physical", "arcane"],
    "specialAction": {
      "id": "elder_dragon_charge",
      "name": "Dive",
      "description": "Fold its wings and fall on a single stack: double damage, guard dropped until the next turn.",
      "kind": "charge"
    }
  },
  {
    "id": "drake_swarm",
    "name": "Drake Swarm",
    "factionId": "dragons",
    "attack": 9,
    "defence": 12,
    "health": 360,
    "damageMin": 8,
    "damageMax": 16,
    "specialty": "Cinderpeak's lesser fliers, quick and many. Scale enough to shrug off a loose arrow, not enough to shrug off a volley meant for them.",
    "initiative": 13,
    "tags": ["dragon", "beast"],
    "damageType": "fire",
    "resistances": ["fire"]
  },
  {
    "id": "mire_troll",
    "name": "Mire Trolls",
    "factionId": "trolls",
    "attack": 10,
    "defence": 6,
    "health": 115,
    "damageMin": 12,
    "damageMax": 20,
    "specialty": "Bigger and hungrier than the cave kind, and just as quick to close a wound. Fire is still the only word that means anything to them.",
    "initiative": 3,
    "tags": ["troll", "beast"],
    "damageType": "physical",
    "resistances": ["physical"],
    "specialAction": {
      "id": "mire_troll_regenerate",
      "name": "Knit Flesh",
      "description": "Torn muscle closes over: the stack recovers a large part of its lost strength.",
      "kind": "regenerate"
    }
  },
  {
    "id": "troll_hurler",
    "name": "Troll Hurlers",
    "factionId": "trolls",
    "attack": 8,
    "defence": 5,
    "health": 75,
    "damageMin": 8,
    "damageMax": 16,
    "specialty": "Trolls that fight at a distance, flinging stones the size of a man's chest. They mend the same as any troll; only burning ends them.",
    "initiative": 4,
    "tags": ["troll", "ranged", "beast"],
    "damageType": "physical",
    "resistances": ["physical"],
    "specialAction": {
      "id": "troll_hurler_regenerate",
      "name": "Knit Flesh",
      "description": "Torn muscle closes over: the stack recovers a large part of its lost strength.",
      "kind": "regenerate"
    }
  },
  {
    "id": "frost_giant",
    "name": "Frost Giants",
    "factionId": "giants",
    "attack": 12,
    "defence": 9,
    "health": 155,
    "damageMin": 16,
    "damageMax": 28,
    "specialty": "The taller kin of the hill giants, out of the high cold of Colossus Vale. Fire troubles them least of anything, and reaching them is the whole problem.",
    "initiative": 2,
    "tags": ["giant"],
    "damageType": "physical",
    "resistances": ["fire"],
    "specialAction": {
      "id": "frost_giant_sunder",
      "name": "Overhand Smash",
      "description": "A blow with the whole mountain behind it: ignores the target's defence and resistances.",
      "kind": "sunder"
    }
  },
  {
    "id": "giant_earthshaker",
    "name": "Giant Earthshakers",
    "factionId": "giants",
    "attack": 11,
    "defence": 10,
    "health": 175,
    "damageMin": 18,
    "damageMax": 30,
    "specialty": "Eldest and slowest of the Vale, who bring down walls by leaning on them. Dwarves are the only people who have ever reliably brought one down first.",
    "initiative": 1,
    "tags": ["giant", "fortification"],
    "damageType": "physical",
    "resistances": [],
    "counters": { "fortification": 1.8 },
    "specialAction": {
      "id": "giant_earthshaker_sunder",
      "name": "Ground Strike",
      "description": "A blow that shakes the footing out from under a stack: ignores defence and resistances.",
      "kind": "sunder"
    }
  },
  {
    "id": "death_knights",
    "name": "Death Knights",
    "factionId": "undead",
    "attack": 11,
    "defence": 9,
    "health": 42,
    "damageMin": 8,
    "damageMax": 14,
    "specialty": "Champions the Necromancer kept and killed and kept again. Steel finds little to bite; holy force and the breaking of their anchor are the answers.",
    "initiative": 9,
    "tags": ["undead", "cavalry"],
    "damageType": "shadow",
    "resistances": ["physical", "piercing", "shadow"],
    "specialAction": {
      "id": "death_knights_charge",
      "name": "Dead Charge",
      "description": "Ride down a stack without fear or hesitation: double damage, guard dropped until the next turn.",
      "kind": "charge"
    }
  },
  {
    "id": "bone_colossus",
    "name": "Bone Colossus",
    "factionId": "undead",
    "attack": 10,
    "defence": 8,
    "health": 135,
    "damageMin": 14,
    "damageMax": 24,
    "specialty": "A hill of lashed-together dead the size of a giant, held up by the same anchor as the rest. Throw down the anchor and it collapses into what it was made of.",
    "initiative": 2,
    "tags": ["undead", "giant"],
    "damageType": "physical",
    "resistances": ["piercing", "shadow"],
    "specialAction": {
      "id": "bone_colossus_sunder",
      "name": "Crush",
      "description": "Brings a fist the size of a cart down on a stack: ignores defence and resistances.",
      "kind": "sunder"
    }
  },
  {
    "id": "dark_elf_assassins",
    "name": "Dark Elf Assassins",
    "factionId": "dark_elves",
    "attack": 12,
    "defence": 6,
    "health": 26,
    "damageMin": 8,
    "damageMax": 15,
    "specialty": "The Matron's own killers, who open a fight from a place no one knew held anyone. Find them first or do not fight them at all.",
    "initiative": 14,
    "tags": ["dark_elf", "hero"],
    "damageType": "shadow",
    "resistances": ["shadow"],
    "startsConcealed": true,
    "specialAction": {
      "id": "dark_elf_assassins_frenzy",
      "name": "Killing Flurry",
      "description": "A burst of strikes at far greater damage, at the cost of all defence until the next turn.",
      "kind": "frenzy"
    }
  },
  {
    "id": "dark_elf_webcasters",
    "name": "Dark Elf Webcasters",
    "factionId": "dark_elves",
    "attack": 7,
    "defence": 4,
    "health": 11,
    "damageMin": 4,
    "damageMax": 8,
    "specialty": "They snare a battlefield in shadow and shoot from inside it. Nothing that cannot find them can answer them.",
    "initiative": 10,
    "tags": ["dark_elf", "ranged"],
    "damageType": "shadow",
    "resistances": ["shadow"],
    "startsConcealed": true
  },
  {
    "id": "hellhound_pack",
    "name": "Hellhound Pack",
    "factionId": "demon_spirits",
    "attack": 9,
    "defence": 5,
    "health": 32,
    "damageMin": 6,
    "damageMax": 12,
    "specialty": "The first things through the tear, and the fastest. Killing them is easy and meaningless while the Veil keeps sending more.",
    "initiative": 12,
    "tags": ["demon", "beast"],
    "damageType": "fire",
    "resistances": ["fire", "shadow"],
    "specialAction": {
      "id": "hellhound_pack_charge",
      "name": "Pack Rush",
      "description": "The whole pack breaks into a run at once: double damage, guard dropped until the next turn.",
      "kind": "charge"
    }
  },
  {
    "id": "veil_horror",
    "name": "Veil Horror",
    "factionId": "demon_spirits",
    "attack": 12,
    "defence": 8,
    "health": 165,
    "damageMin": 14,
    "damageMax": 26,
    "specialty": "What comes through last, and worst, when the tear is left open long enough. Steel and fire both slide off it; only unmaking the Veil unmakes it.",
    "initiative": 6,
    "tags": ["demon"],
    "damageType": "shadow",
    "resistances": ["shadow", "physical", "fire"],
    "specialAction": {
      "id": "veil_horror_frenzy",
      "name": "Unspeakable Assault",
      "description": "A frenzy of limbs at far greater damage, at the cost of all defence until the next turn.",
      "kind": "frenzy"
    }
  },
  {
    "id": "the_necromancer",
    "name": "The Necromancer",
    "factionId": "necromancer",
    "attack": 18,
    "defence": 13,
    "health": 220,
    "damageMin": 16,
    "damageMax": 30,
    "specialty": "The maker of the ritual, and the anchor every dead thing in the citadel is hung from. Steel, arrows and fire all slide off five hundred days of wards. Only holy force and the unmaking of a binding reach him — Radiant Seraph, Spirit Wardens, Ritual Mages. He is himself a binding; fight him like one, and do not waste a blow on the dead he raises.",
    "initiative": 12,
    "tags": [
      "undead",
      "anchor",
      "hero"
    ],
    "damageType": "shadow",
    "resistances": [
      "physical",
      "piercing",
      "fire",
      "shadow"
    ],
    "specialAction": {
      "id": "the_necromancer_sunder",
      "name": "Word of Unmaking",
      "description": "A syllable of the great ritual turned on a single stack. Ignores defence and resistances entirely.",
      "kind": "sunder"
    }
  }
]
